"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactCsv = require("react-csv");
var _CoreTable = _interopRequireDefault(require("./CoreTable"));
var _CoreProps = require("../../utilities/CoreProps");
var _CoreTableUtils = require("./CoreTableUtils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const ReportingTable = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const tableReference = (0, _react.useRef)();
  const showPaginationDefault = typeof props.showPagination !== 'undefined' ? props.showPagination : true;
  const [showPagination, setShowPagination] = (0, _react.useState)(showPaginationDefault);
  const [defaultExpanded, setDefaultExpanded] = (0, _react.useState)(props.defaultExpanded);
  const [printCounter, setPrintCounter] = (0, _react.useState)(0);
  (0, _react.useLayoutEffect)(() => {
    if (printCounter > 0) {
      if (!props.handlePrint) {
        window.print();
      } else {
        props.handlePrint();
      }
    }
  }, [printCounter]);
  (0, _react.useEffect)(() => {
    const handleAfterPrint = () => {
      setShowPagination(true);
      setDefaultExpanded(props.defaultExpanded);
    };
    window.addEventListener('afterprint', handleAfterPrint);
    return () => {
      window.removeEventListener('afterprint', handleAfterPrint);
    };
  }, []);
  (0, _react.useImperativeHandle)(ref, () => ({
    getSelections: () => {
      const table = tableReference.current;
      return table.getSelections();
    }
  }));
  let csvColumns;
  if (props.csvColumnDefinitions) {
    csvColumns = props.csvColumnDefinitions.filter(col => col.visible && typeof col.csv === 'undefined' || col.csv);
  }
  if (props.columnDefinitions && !props.csvColumnDefinitions) {
    csvColumns = props.columnDefinitions.filter(col => col.visible && typeof col.csv === 'undefined' || col.csv);
  }
  const csvHeaders = csvColumns.map(item => item.Header || item.header);
  const tempData = [...props.data];
  const formattedData = tempData.map(row => {
    const tempRow = [];
    csvColumns.forEach(col => {
      if (col.accessor in row && (!col.accessors || col.accessors.length === 0)) {
        tempRow.push((0, _CoreTableUtils.formatData)(col, row[col.accessor]));
      }
      if (col.accessors && col.accessors.length > 0) {
        const values = Object.entries(row).filter(_ref => {
          let [key] = _ref;
          return col.accessors.includes(key);
        }).map(_ref2 => {
          let [, value] = _ref2;
          return value;
        });
        tempRow.push(values.join('\n'));
      }
    });
    return tempRow;
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('reporting-table-container', props.className) || undefined
  }, props.data && /*#__PURE__*/_react.default.createElement("div", {
    className: "reporting-table-toolbar is-flex is-justify-content-flex-end mr-2 is-hidden-print"
  }, props.printEnabled &&
  /*#__PURE__*/
  // Disable linting rule to make anchor consistent with CSVLink
  // eslint-disable-next-line jsx-a11y/anchor-is-valid
  _react.default.createElement("a", {
    className: "icon is-clickable",
    onClick: () => {
      setDefaultExpanded(true);
      setShowPagination(false);
      setPrintCounter(printCounter + 1);
    },
    onKeyUp: () => {
      setDefaultExpanded(true);
      setShowPagination(false);
      setPrintCounter(printCounter + 1);
    },
    role: "button",
    tabIndex: -2,
    alt: "Download"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons"
  }, "print")), !props.handleDownload && props.downloadEnabled && /*#__PURE__*/_react.default.createElement(_reactCsv.CSVLink, {
    data: formattedData,
    headers: csvHeaders,
    filename: `${props.reportName ? props.reportName : 'Download'}.csv`
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon is-clickable ml-3"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons"
  }, "save_alt"))), props.handleDownload && props.downloadEnabled &&
  /*#__PURE__*/
  // Disable linting rule to make anchor consistent with CSVLink
  // eslint-disable-next-line jsx-a11y/anchor-is-valid
  _react.default.createElement("a", {
    className: "icon is-clickable ml-3",
    onClick: () => props.handleDownload(),
    onKeyUp: () => props.handleDownload(),
    role: "button",
    tabIndex: -1
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons"
  }, "save_alt"))), /*#__PURE__*/_react.default.createElement(_CoreTable.default, _extends({
    ref: tableReference
    // Nesc to send dynamic props to Table
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, props, {
    defaultExpanded: defaultExpanded,
    showPagination: showPagination,
    key: `standardtable_pagination_${showPagination}`
  })));
});
ReportingTable.displayName = 'ReportingTable';
ReportingTable.propTypes = {
  csvColumnDefinitions: _propTypes.default.arrayOf(_propTypes.default.shape({
    accessor: _propTypes.default.string,
    accessors: _propTypes.default.arrayOf(_propTypes.default.string),
    visible: _propTypes.default.bool,
    csv: _propTypes.default.bool,
    Header: _propTypes.default.string,
    header: _propTypes.default.string
  })),
  columnDefinitions: _propTypes.default.arrayOf(_propTypes.default.shape({
    accessor: _propTypes.default.string,
    accessors: _propTypes.default.arrayOf(_propTypes.default.string),
    visible: _propTypes.default.bool,
    csv: _propTypes.default.bool,
    Header: _propTypes.default.string,
    header: _propTypes.default.string
  })),
  // Nesc since data comes in different shapes
  // eslint-disable-next-line react/forbid-prop-types
  data: _propTypes.default.array,
  handlePrint: _propTypes.default.func,
  handleDownload: _propTypes.default.func,
  printEnabled: _propTypes.default.bool,
  downloadEnabled: _propTypes.default.bool,
  reportName: _propTypes.default.string,
  noRowsText: _propTypes.default.string,
  selectTable: _propTypes.default.bool,
  expanderCircle: _propTypes.default.bool,
  defaultExpanded: _propTypes.default.bool,
  showPagination: _propTypes.default.bool,
  showPageInfo: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  isExpanded: _propTypes.default.bool,
  pageSize: _propTypes.default.number,
  className: _propTypes.default.string,
  defaultSorted: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string,
    desc: _propTypes.default.bool
  }))
};
ReportingTable.defaultProps = {
  showPageInfo: true,
  showPagination: true,
  expanderCircle: false,
  loading: false,
  downloadEnabled: true,
  printEnabled: true,
  defaultSorted: []
};
var _default = exports.default = (0, _CoreProps.withUiProps)(ReportingTable);
//# sourceMappingURL=ReportingTable.js.map